import { k } from "../kaplay";

export function addPlayButton(p = k.vec2(200, 100), f = () => debug.log("hello")) {
  // add a parent background object
  const btn = k.add([
    k.sprite("play"),
    k.pos(p),
    k.area(),
    k.scale(3),
    k.anchor("center"),
    k.outline(4),
    k.color(255, 255, 255),
  ]);
  
  // onHoverUpdate() comes from area() component
  // it runs every frame when the object is being hovered
  btn.onHoverUpdate(() => {
    btn.scale = k.vec2(3.1);
    k.setCursor("pointer");
  });
  
  // onHoverEnd() comes from area() component
  // it runs once when the object stopped being hovered
  btn.onHoverEnd(() => {
    btn.scale = k.vec2(3);
  });
  
  // onClick() comes from area() component
  // it runs once when the object is clicked
  btn.onClick(f);
  
  return btn;
}